class AppBootstrap
	constructor: ->
		DI = angular.injector([
			'ng'
			'App.Service'
			'App.Repository'
			'App.Constant.Configuration'
			'App.Constant.Common'
			'LocalStorageModule'
		])

		services = [
			'$http'
			'$q'
			'CredentialsManager'
			'API_ENDPOINT'
		]

		for service in services
			@[service] = DI.get(service)

	boot: ->
		angular.bootstrap(angular.element('#ng-app'), ['App'])

	checkImplicitLogin: ->
		url = new URL(window.location)
		accessToken = url.searchParams.get('access_token')

		if !accessToken?
			return @$q.when true

		referrer = url.searchParams.get('referrer')
		angular.element('#auto-login-notification').show();
		url.searchParams.delete('access_token')
		url.searchParams.delete('referrer')

		window.history.replaceState {}, '', url

		@CredentialsManager.clear()

		payload =
			client_id: 'backoffice'
			grant_type: 'login_token'
			login_token: accessToken
			scope: 'backoffice'

		return @$http
			.post "#{@API_ENDPOINT}/auth/token", payload
			.then (response) =>
				@CredentialsManager.setAccessToken(response.data.access_token)
				@CredentialsManager.setAccessTokenExpireTime(response.data.expires_in)
				@CredentialsManager.setRefreshToken(response.data.refresh_token)

				if referrer
					@CredentialsManager.setReferrer(referrer)
			.catch (error) =>
				console.error(error)
				@boot()
			.finally =>
				angular.element('#auto-login-notification').hide();

	initialize: ->
		@checkImplicitLogin().then =>
			if @CredentialsManager.getAccessToken() == null
				@boot()

				return

			@$http
				.get "#{@API_ENDPOINT}/auth/token", @CredentialsManager.injectAccessToken()
				.then (statusResponse) =>
					@loadResources(statusResponse.data)

					return
				.catch (statusResponse) =>
					if statusResponse instanceof Error
						console.error(statusResponse)

					if statusResponse.status != 401 || statusResponse.data.error_key != 'access_denied'
						return @boot()

					@refreshToken().finally =>
						@initialize()

	refreshToken: ->
		refreshToken = @CredentialsManager.getRefreshToken()

		if not refreshToken?
			@CredentialsManager.clear()

			return @$q.reject('no_refresh_token')

		payload =
			client_id: 'backoffice'
			grant_type: 'refresh_token'
			refresh_token: refreshToken
			scope: 'backoffice'

		return @$http
			.post "#{@API_ENDPOINT}/auth/token", payload
			.then (response) =>
				@CredentialsManager.setAccessToken(response.data.access_token)
				@CredentialsManager.setAccessTokenExpireTime(response.data.expires_in)
				@CredentialsManager.setRefreshToken(response.data.refresh_token)
			.catch (error) =>
				console.error(error)

				@CredentialsManager.clear()

	loadResources: (data) ->
		(new StaticResourcePreloader())
			.loadResources(data.master_user.id, data.sub_user?.id)
			.catch (error) =>
				console.error error
				@CredentialsManager.clear()
			.finally =>
				@boot()

angular
	.element document
	.ready ->
		(new AppBootstrap()).initialize()
